import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../store/AuthContext";
import { ROUTES } from "./AppRoutes";
import { Spinner } from "@chakra-ui/react";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to={ROUTES.LOGIN} replace />;
}

export default ProtectedRoute;
